export default "__VITE_ASSET__9b126a76__"